import React from 'react';
import { createRoot } from 'react-dom/client';
import { initI18nFromSSR } from './i18n/initFromSSR';
import ProductQuickAddToCart, { ProductQuickAddToCartProps } from './features/productquickaddtocart/ProductQuickAddToCart';
/**
 * Modal + delegate click cho `.product-quick-add-to-cart-btn` (main.js).
 * Trang /cart chỉ load entry này + cart.tsx, không load main.js → phải khởi tạo vanilla ở đây
 * để nút mắt trên CartDetailItem mở được modal.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- default export từ module .js
import ProductQuickAddToCartVanilla from '../js/modules/product-quick-add-to-cart.js';

// Initialize i18n promise (only once, shared across renders)
const i18nInitPromise = initI18nFromSSR();

if (typeof window !== 'undefined' && !(window as any).productQuickAddToCart) {
    (window as any).productQuickAddToCart = new (ProductQuickAddToCartVanilla as any)();
}

// Export render function for use in main.js
const ProductQuickAddToCartReact = {
    render: (container: HTMLElement, props: ProductQuickAddToCartProps) => {
        // Đợi translations load xong trước khi render
        i18nInitPromise.then(() => {
            const root = createRoot(container);
            root.render(<ProductQuickAddToCart {...props} />);
        });
    }
};

// Make it available globally immediately when this module loads
(window as any).ProductQuickAddToCartReact = ProductQuickAddToCartReact;

export default ProductQuickAddToCart;
